export default __webpack_public_path__ + "static/media/7 DRONES.ff6e78a8.png";